<div class="contact-form--container">
    <form [formGroup]="contactForm" class="form">
        <ng-container formArrayName="contact_details">
            <ng-container *ngFor="let contact_detail of contactDetailGroups; let i = index">

                <!-- Main contact row – only render if showMainContacts is true -->
                <div class="form-row"
                     [formGroup]="contact_detail"
                     *ngIf="showMainContacts && contact_detail.controls.main?.value">

                    <!-- Main Contact Name -->
                    <div class="col">
                        <div class="form-group" [ngClass]="validationClassName(contact_detail.controls.contact)">
                            <label class="form-control-label font-weight-bold" [for]="'contact_' + i">
                                {{ addressBookFeatures.mainContactNameLabel }}
                                <span *ngIf="addressBookFeatures.mainContactNameRequired"
                                      class="color--alert mr-1">*</span>
                            </label>
                            <input class="form-control" [id]="'contact_' + i" maxlength="255" formControlName="contact"
                                   trim placeholder="Enter Name" (input)="onInputChange()">
                            <small class="text-danger"
                                   *ngIf="contact_detail.controls.contact.errors?.required && contact_detail.controls.main.value && (contact_detail.controls.contact.touched || contact_detail.controls.contact.dirty)">
                                {{ addressBookFeatures.mainContactNameLabel }} field is required.
                            </small>
                        </div>
                    </div>

                    <!-- Main Contact Email -->
                    <div class="col">
                        <div class="form-group" [ngClass]="validationClassName(contact_detail.controls.email)">
                            <label class="form-control-label font-weight-bold" [for]="'email_' + i">
                                {{ addressBookFeatures.mainContactEmailLabel }}
                                <span *ngIf="addressBookFeatures.mainContactEmailRequired"
                                      class="color--alert mr-1">*</span>
                            </label>
                            <input class="form-control" [id]="'email_' + i" maxlength="255" formControlName="email" trim
                                   placeholder="Enter Email Address" (input)="onInputChange()">
                            <small class="text-danger" *ngIf="contact_detail.controls.email.errors?.pattern">Please
                                enter a valid email address.</small>
                            <small class="text-danger"
                                   *ngIf="contact_detail.controls.email.errors?.required && (contact_detail.controls.email.touched || contact_detail.controls.email.dirty)">
                                {{ addressBookFeatures.mainContactEmailLabel }} field is required.
                            </small>
                        </div>
                    </div>

                    <!-- Spacer column (no trash for main contact) -->
                    <div class="col-1">
                        &nbsp;
                    </div>

                </div>

                <!-- Additional contact rows -->
                <ng-container *ngIf="showAdditionalContacts && !contact_detail.controls.main.value">

                    <!-- Heading appears only before the first additional contact -->
                    <h4 class="text-uppercase text-decoration-none mt-4 mb-3"
                        *ngIf="i === 1 || (i > 0 && contact_details.controls[i-1]?.get('main')?.value)">
                        Additional Contact Details
                    </h4>

                    <div class="form-row" [formGroup]="contact_detail">

                        <!-- Additional Contact Name -->
                        <div class="col">
                            <div class="form-group" [ngClass]="validationClassName(contact_detail.controls.contact)">
                                <label class="form-control-label font-weight-bold" [for]="'contact_' + i">
                                    {{ addressBookFeatures.additionalContactNameLabel }}
                                    <span *ngIf="addressBookFeatures.additionalContactNameRequired"
                                          class="color--alert mr-1">*</span>
                                </label>
                                <input class="form-control" [id]="'contact_' + i" maxlength="255"
                                       formControlName="contact" trim placeholder="Enter Name"
                                       (input)="onInputChange()">
                                <small class="text-danger"
                                       *ngIf="contact_detail.controls.contact.errors?.required && (contact_detail.controls.contact.touched || contact_detail.controls.contact.dirty)">
                                    {{ addressBookFeatures.additionalContactNameLabel }} field is required.
                                </small>
                            </div>
                        </div>

                        <!-- Additional Contact Email -->
                        <div class="col">
                            <div class="form-group" [ngClass]="validationClassName(contact_detail.controls.email)">
                                <label class="form-control-label font-weight-bold" [for]="'email_' + i">
                                    {{ addressBookFeatures.additionalContactEmailLabel }}
                                    <span *ngIf="addressBookFeatures.additionalContactEmailRequired"
                                          class="color--alert mr-1">*</span>
                                </label>
                                <input class="form-control" [id]="'email_' + i" maxlength="255" formControlName="email"
                                       trim placeholder="Enter Email Address" (input)="onInputChange()">
                                <small class="text-danger" *ngIf="contact_detail.controls.email.errors?.pattern">Please
                                    enter a valid email address.</small>
                                <small class="text-danger"
                                       *ngIf="contact_detail.controls.email.errors?.required && (contact_detail.controls.email.touched || contact_detail.controls.email.dirty)">
                                    {{ addressBookFeatures.additionalContactEmailLabel }} field is required.
                                </small>
                            </div>
                        </div>

                        <!-- Remove button -->
                        <div class="col-1">
                            <div class="d-flex h-100">
                                <button type="button"
                                        (click)="onRemoveContactDetail(i)"
                                        class="btn btn-icon w-100 btn-remove mt-4"
                                        title="Remove this additional contact"
                                        aria-label="Remove this additional contact">
                                    <i class="fal fa-trash-alt" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>

                    </div>
                </ng-container>

            </ng-container>
        </ng-container>
    </form>

    <button type="button" *ngIf="showAdditionalContacts" class="btn btn-outline-primary mb-4"
            [disabled]="contact_details.controls.length === numberOfAdditionalFields" (click)="onAddContactDetail()">
        Add Additional Contact +
    </button>
</div>
